import { Injectable } from '@angular/core';
import { CommonService } from './common.service';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    constructor(private commonService: CommonService
    ) { }

    /** Get Session Data */
    getSessionStorageData(key: string): any {
    let storageData = sessionStorage.getItem(key);
    if (!storageData) {
        // No data stored under the key
        // console.warn(`No sessionStorage data found for key: ${key}`);
        return null;
    }
    try {
        let decryptedStorageData = this.commonService.decryptUsingAES256(storageData);
        return decryptedStorageData;
    } catch (error) {
        console.error(`Error decrypting sessionStorage data for key: ${key}`, error);
        // Return null or some fallback value to avoid breaking app flow
        return null;
    }
}

    /** Set Session Data */
    setSessionStorageData(key: string, storageData: any): void {
        let encryptedStorageData = this.commonService.encryptUsingAES256(storageData);
        sessionStorage.setItem(key, encryptedStorageData);
    }

    /** Remove Session Data */
    removeSessionStorageData(key: string): void {
        if (sessionStorage.getItem(key)) {
            sessionStorage.removeItem(key);
        }
    }

    /** Remove All Session Data */
    clearAllSessionStorageData() {
        const isArabic = this.getSessionStorageData('isArabic');
        sessionStorage.clear();
        this.setSessionStorageData('isArabic', isArabic);

    }
}
